module.exports = __webpack_public_path__ + "img/servicepro_login_dark.f7f7e072.png";